import { Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[ngReady]'
})
export class OnReadyDirective {
  @Output() 
  public onReady: EventEmitter<void>;

  constructor() {
    this.onReady = new EventEmitter();
  }

  @Input()
  set ready(isReady: boolean) {
    if (isReady) {
      this.onReady.emit();
    };
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/on-ready/on-ready.directive.ts